import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useState, useEffect } from "react"
import { Container, Alert } from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import user1 from "../../assets/images/user-green.png"
import maleAvatar from "../../assets/images/users/male-avatar.png"
import femaleAvatar from "../../assets/images/users/female-avatar.png"
import othersAvatar from "../../assets/images/users/others-avatar.png"
import QRCode from "qrcode"
import { editProfile, resetProfileFlag } from "../../store/actions"

let BgPhone =
  "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/FujiFilm%20Annual%20Day%202026%2FLogin%20Phone.png?alt=media&token=4082789d-a457-4020-965b-c85c3f47e53b"
let BgLaptop =
  "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/FujiFilm%20Annual%20Day%202026%2FLogin%20Laptop.png?alt=media&token=b1b4edc5-2bf7-46f5-9c13-e1716bb13b7f"

/* ─── component ─────────────────────────────────────────────── */
const UserProfile = props => {
  const [prof, setprof] = useState(user1)
  const [email, setemail] = useState("")
  const [name, setname] = useState("")
  const [idx, setidx] = useState(1)
  const [qrImageUrl, setQrImageUrl] = useState(null)
  const [badgeType, setBadgeType] = useState("")
  const [ticketVarient, setTicketVarient] = useState("")
  const [qrOpen, setQrOpen] = useState(false)

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        setname(
          (obj.Firstname ? obj.Firstname : "") +
            " " +
            (obj.Lastname ? obj.Lastname : "")
        )
        setemail(obj.EmailAddress || obj.Email || "")
        setBadgeType(obj.badgeType || "Accelerate 2026")
        setTicketVarient(obj.Ticket_Variant || "Attendee")
        setidx(obj._id)
        if (obj.SelectedAvatar === "maleAvatar") setprof(maleAvatar)
        else if (obj.SelectedAvatar === "femaleAvatar") setprof(femaleAvatar)
        else if (obj.SelectedAvatar === "othersAvatar") setprof(othersAvatar)
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        setname(obj.username)
        setemail(obj.email)
        setidx(obj.uid)
      }
    }
  }, [props.success])

  useEffect(() => {
    const loader = document.querySelector(".loader")
    if (loader) {
      setTimeout(() => {
      loader.classList.add("loader--hide")
    }, 100)
    }

    const obj = JSON.parse(localStorage.getItem("authUser"))
    if (obj?._id) {
      QRCode.toDataURL(obj._id).then(url => setQrImageUrl(url))
    }

    if (obj?.EmailAddress || obj?.Email) {
      fetch(process.env.REACT_APP_ADMIN + "/updateProfile/getprof", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ Email: obj.EmailAddress || obj.Email }),
      })
        .then(r => r.json())
        .then(data => {
          if (data.Profile) setprof(data.Profile)
        })
        .catch(() => {})
    }
  }, [])

  function handleValidSubmit(event, values) {
    props.editProfile(values)
    setTimeout(() => window.location.reload(), 1000)
  }

  return (
    <React.Fragment>
      <div className="prof-page">
        <MetaTags>
          <title>Profile</title>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, maximum-scale=1"
          />
        </MetaTags>

        <Container fluid className="prof-container">
          {/* Header */}
          <header className="prof-header-bar">
            <div className="prof-header-line" />
            <h1 className="prof-header-title">
              <span className="prof-header-bracket">[</span>
              PROFILE
              <span className="prof-header-bracket">]</span>
            </h1>
            <div className="prof-header-line" />
          </header>

          {/* Alerts */}
          {props.error && (
            <Alert color="danger" className="prof-alert">
              {props.error}
            </Alert>
          )}
          {props.success && (
            <Alert color="success" className="prof-alert">
              {props.success}
            </Alert>
          )}

          {/* ── Avatar card ── */}
          <div className="prof-card prof-avatar-card">
            <div className="prof-card-bar" />
            <div className="prof-avatar-body">

              {/* Avatar ring */}
              <div className="prof-avatar-ring">
                <img src={prof} alt="avatar" className="prof-avatar-img" />
              </div>

              {/* Name + email */}
              <div className="prof-identity">
                <h5 className="prof-name">{name || "—"}</h5>
                <p className="prof-email">{email || "—"}</p>
              </div>

              {/* QR code tap button */}
              {/* {qrImageUrl && (
                <div
                  className="prof-qr-btn"
                  onClick={() => setQrOpen(true)}
                  role="button"
                  aria-label="View QR Code"
                >
                  <div className="prof-qr-glow" />
                  <div className="prof-qr-inner">
                    <img
                      src={qrImageUrl}
                      alt="QR Code"
                      className="prof-qr-thumb"
                    />
                    <div className="prof-qr-pulse-ring" />
                  </div>
                  <span className="prof-qr-cta">Tap to scan</span>
                </div>
              )} */}

              {/* QR full-screen modal */}
              {qrOpen && (
                <div
                  className="prof-qr-modal-overlay"
                  onClick={() => setQrOpen(false)}
                >
                  <div
                    className="prof-qr-modal"
                    onClick={e => e.stopPropagation()}
                  >
                    <div className="prof-qr-modal-bar" />
                    <div className="prof-qr-modal-header">
                      <button
                        className="prof-qr-modal-close"
                        onClick={() => setQrOpen(false)}
                      >
                        ✕
                      </button>
                    </div>
                    <div className="prof-qr-modal-body">
                      <div className="prof-qr-modal-frame">
                        <div className="prof-qr-pulse-ring" />
                        <img
                          src={qrImageUrl}
                          alt="QR Code"
                          className="prof-qr-modal-img"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Badges */}
              {/* <div className="prof-badges">
                <div className="prof-badge">
                  <span className="prof-badge-icon">🎫</span>
                  <span className="prof-badge-text">{ticketVarient}</span>
                </div>
                <div className="prof-badge">
                  <span className="prof-badge-icon">⭐</span>
                  <span className="prof-badge-text">{badgeType}</span>
                </div>
              </div> */}
            </div>
          </div>

          {/* ── Form card ── */}
          <div className="prof-card prof-form-card">
            <div className="prof-card-bar" />
            <div className="prof-form-body">
              <h4 className="prof-section-title">Edit Profile</h4>

              <AvForm
                className="form-horizontal"
                onValidSubmit={(e, v) => handleValidSubmit(e, v)}
              >
                <div className="prof-field">
                  <label className="prof-label">Full Name</label>
                  <AvField
                    name="Name"
                    value={name}
                    className="form-control prof-input"
                    placeholder="Enter Full Name"
                    type="text"
                    required
                  />
                </div>

                <div className="prof-field">
                  <label className="prof-label">Email</label>
                  <AvField
                    name="Email"
                    value={email}
                    className="form-control prof-input prof-input-disabled"
                    placeholder="Email"
                    type="email"
                    disabled
                  />
                  <AvField name="idx" value={idx} type="hidden" />
                </div>

                <button type="submit" className="prof-save-btn">
                  Save Changes
                </button>
              </AvForm>
            </div>
          </div>

          {/* Footer label */}
          <div className="prof-footer-label">
            FujiFilm Annual Day 2026 · Accelerate
          </div>
        </Container>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Rajdhani:wght@500;600;700&display=swap');

        /* ── THEME TOKENS ── */
        :root {
          --brand-deep:    #0e4d35;
          --brand-mid:     #1a8a58;
          --brand-light:   #4db87a;
          --brand-pale:    #e0f2eb;
          --brand-bg:      #f0f4f2;
          --brand-surface: #ffffff;
          --brand-border:  #c8dfd4;
          --brand-muted:   #6b9d88;
          --brand-hover:   rgba(26,138,88,.12);
          --font-display:  'Rajdhani', sans-serif;
          --font-body:     'Inter', sans-serif;
        }

        /* ── PAGE ── */
        .prof-page {
          min-height: 100vh;
          background: var(--brand-bg);
          position: relative;
          overflow: hidden;
          margin-top: 55px;
        }

        /* Subtle decorative background blobs */
        .prof-page::before,
        .prof-page::after {
          content: '';
          position: fixed;
          border-radius: 50%;
          pointer-events: none;
          z-index: 0;
          opacity: .45;
        }
        .prof-page::before {
          width: 420px; height: 420px;
          top: -120px; right: -100px;
          background: radial-gradient(circle, rgba(77,184,122,.18) 0%, transparent 70%);
        }
        .prof-page::after {
          width: 340px; height: 340px;
          bottom: -80px; left: -80px;
          background: radial-gradient(circle, rgba(14,77,53,.12) 0%, transparent 70%);
        }

        /* ── LAYOUT ── */
        .prof-container {
          position: relative; z-index: 1;
          max-width: 480px !important;
          margin: 0 auto !important;
          padding: 0 14px !important;
        }

        /* ── HEADER ── */
        .prof-header-bar {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: clamp(18px, 4vh, 32px) 0 clamp(14px, 2.5vh, 22px);
        }
        .prof-header-line {
          flex: 1; height: 1px;
          background: linear-gradient(90deg, transparent, var(--brand-mid), transparent);
        }
        .prof-header-title {
          font-family: var(--font-display);
          font-size: clamp(1.5rem, 4vw, 2.4rem);
          font-weight: 700;
          letter-spacing: .22em;
          color: var(--brand-deep);
          white-space: nowrap;
          animation: profTitleIn .7s cubic-bezier(.22,1,.36,1) both;
        }
        @keyframes profTitleIn {
          from { opacity:0; transform:translateY(-12px); }
          to   { opacity:1; transform:translateY(0); }
        }
        .prof-header-bracket {
          color: var(--brand-light);
          opacity: .7;
          font-weight: 400;
        }

        /* ── ALERTS ── */
        .prof-alert {
          border-radius: 10px;
          margin-bottom: 12px;
          font-family: var(--font-body);
        }

        /* ── CARDS ── */
        .prof-card {
          border-radius: 16px;
          overflow: hidden;
          margin-bottom: 16px;
          background: var(--brand-surface) !important;
          border: 1px solid var(--brand-border) !important;
          box-shadow:
            0 2px 16px rgba(14,77,53,.08),
            0 1px 3px rgba(14,77,53,.06);
          opacity: 0;
          transform: translateY(18px);
          animation: profSlideUp .5s cubic-bezier(.22,1,.36,1) forwards;
        }
        .prof-avatar-card { animation-delay: .08s; }
        .prof-form-card   { animation-delay: .18s; }

        @keyframes profSlideUp {
          to { opacity:1; transform:translateY(0); }
        }

        /* shimmer top bar — brand green */
        .prof-card-bar {
          height: 4px;
          background: linear-gradient(
            90deg,
            var(--brand-deep) 0%,
            var(--brand-mid) 35%,
            var(--brand-light) 60%,
            var(--brand-mid) 80%,
            var(--brand-deep) 100%
          );
          background-size: 300% 100%;
          animation: profShimmer 3s linear infinite;
        }
        @keyframes profShimmer {
          0%   { background-position: 100% 0; }
          100% { background-position: -100% 0; }
        }

        /* ── AVATAR CARD BODY ── */
        .prof-avatar-body {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 28px 20px 24px;
          gap: 14px;
        }

        /* Avatar ring */
        .prof-avatar-ring {
          width: 96px; height: 96px;
          border-radius: 50%;
          padding: 3px;
          background: linear-gradient(135deg, var(--brand-deep), var(--brand-light), #a8e6c4);
          background-size: 300% 300%;
          animation: profRingRotate 5s ease infinite;
          box-shadow:
            0 0 0 4px var(--brand-pale),
            0 4px 18px rgba(14,77,53,.18);
        }
        @keyframes profRingRotate {
          0%   { background-position: 0% 50%; }
          50%  { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .prof-avatar-img {
          width: 90px; height: 90px;
          border-radius: 50%;
          object-fit: cover;
          display: block;
          background: var(--brand-pale);
        }

        /* Identity */
        .prof-identity { text-align: center; }
        .prof-name {
          font-family: var(--font-body);
          font-size: 1.25rem;
          font-weight: 600;
          color: var(--brand-deep);
          margin: 0 0 4px;
          letter-spacing: .01em;
        }
        .prof-email {
          font-size: .82rem;
          color: var(--brand-muted);
          margin: 0;
        }

        /* ── QR FLOATING BUTTON ── */
        .prof-qr-btn {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          cursor: pointer;
          padding: 14px 14px 6px;
          border-radius: 16px;
          background: var(--brand-pale);
          border: 1px solid var(--brand-border);
          animation: qrFloat 3s ease-in-out infinite;
          transition: transform .15s, box-shadow .15s;
          -webkit-tap-highlight-color: transparent;
        }
        .prof-qr-btn:hover {
          box-shadow: 0 6px 20px rgba(14,77,53,.18);
        }
        .prof-qr-btn:active { transform: scale(.94) !important; }

        @keyframes qrFloat {
          0%,100% { transform: translateY(0px); }
          50%      { transform: translateY(-6px); }
        }

        .prof-qr-glow {
          position: absolute;
          inset: -8px;
          border-radius: 22px;
          background: radial-gradient(circle, rgba(77,184,122,.2) 0%, transparent 70%);
          animation: qrGlowPulse 3s ease-in-out infinite alternate;
          pointer-events: none;
          z-index: -1;
        }
        @keyframes qrGlowPulse {
          from { opacity:.4; transform:scale(.95); }
          to   { opacity:.9; transform:scale(1.04); }
        }

        .prof-qr-inner {
          position: relative;
          width: 80px; height: 80px;
        }
        .prof-qr-thumb {
          width: 80px; height: 80px;
          border-radius: 10px;
          border: 2px solid var(--brand-mid);
          box-shadow: 0 4px 12px rgba(14,77,53,.15);
          display: block;
        }

        .prof-qr-pulse-ring {
          position: absolute;
          inset: -6px;
          border-radius: 14px;
          border: 2px solid rgba(26,138,88,.5);
          animation: qrPulseRing 2s ease-out infinite;
          pointer-events: none;
        }
        @keyframes qrPulseRing {
          0%   { transform:scale(1);    opacity:.8; }
          100% { transform:scale(1.28); opacity:0; }
        }

        .prof-qr-cta {
          font-family: var(--font-display);
          font-size: .8rem;
          font-weight: 700;
          letter-spacing: .1em;
          text-transform: uppercase;
          color: var(--brand-mid);
          animation: qrCtaBlink 2s ease-in-out infinite alternate;
        }
        @keyframes qrCtaBlink {
          from { opacity:.6; }
          to   { opacity:1; }
        }

        /* ── QR MODAL ── */
        .prof-qr-modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,.55);
          backdrop-filter: blur(6px);
          -webkit-backdrop-filter: blur(6px);
          z-index: 9999;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          animation: overlayFadeIn .22s ease;
        }
        @keyframes overlayFadeIn {
          from { opacity:0; }
          to   { opacity:1; }
        }

        .prof-qr-modal {
          height: 100%;
          width: 100%;
          max-width: 480px;
          background: #fff;
          border: 1px solid var(--brand-border);
          border-radius: 18px 18px 0 0;
          overflow: hidden;
          animation: sheetSlideUp .3s cubic-bezier(.22,1,.36,1);
          box-shadow: 0 -8px 40px rgba(14,77,53,.2);
        }
        @keyframes sheetSlideUp {
          from { transform:translateY(100%); opacity:.5; }
          to   { transform:translateY(0);    opacity:1; }
        }

        .prof-qr-modal-bar {
          height: 4px;
          background: linear-gradient(90deg, var(--brand-deep), var(--brand-mid), var(--brand-light), var(--brand-mid), var(--brand-deep));
          background-size: 300% 100%;
          animation: profShimmer 3s linear infinite;
        }

        .prof-qr-modal-header {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding: 0;
          position: absolute;
          top: 4px;
          width: 100%;
          z-index: 99;
        }
        .prof-qr-modal-close {
          background: var(--brand-pale);
          border: 1px solid var(--brand-border);
          color: var(--brand-mid);
          border-radius: 50%;
          width: 32px; height: 32px;
          font-size: 16px;
          cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          transition: background .2s, box-shadow .2s;
          margin: 6px 8px;
        }
        .prof-qr-modal-close:hover {
          background: var(--brand-border);
          box-shadow: 0 0 10px rgba(14,77,53,.2);
        }

        .prof-qr-modal-body {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 14px;
          padding: 20px 24px 18px;
        }

        .prof-qr-modal-frame {
          background: #fff;
          border-radius: 16px;
          border: 3px solid var(--brand-mid);
          width: calc(100% - 0px);
          max-width: 320px;
          box-shadow: 0 0 40px rgba(14,77,53,.12);
          animation: modalQrPop .4s cubic-bezier(.34,1.56,.64,1) .1s both;
          position: relative;
        }
        @keyframes modalQrPop {
          from { transform:scale(.85); opacity:0; }
          to   { transform:scale(1);   opacity:1; }
        }
        .prof-qr-modal-img {
          width: 100%;
          height: auto;
          display: block;
          border-radius: 8px;
        }

        /* ── BADGES ── */
        .prof-badges {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
          justify-content: center;
        }
        .prof-badge {
          display: flex;
          align-items: center;
          gap: 6px;
          background: var(--brand-pale);
          border: 1px solid var(--brand-border);
          border-radius: 20px;
          padding: 5px 13px;
          font-size: .75rem;
          color: var(--brand-deep);
          font-weight: 500;
          font-family: var(--font-body);
          opacity: 0;
          animation: profBadgePop .5s cubic-bezier(.34,1.56,.64,1) forwards;
        }
        .prof-badge:nth-child(1) { animation-delay: .35s; }
        .prof-badge:nth-child(2) { animation-delay: .5s; }
        @keyframes profBadgePop { to { opacity:1; } }
        .prof-badge-icon { font-size: .85rem; }
        .prof-badge-text { font-weight: 500; }

        /* ── FORM CARD BODY ── */
        .prof-form-body { padding: 22px 18px 24px; }
        .prof-section-title {
          font-family: var(--font-display);
          font-size: 1.1rem;
          font-weight: 700;
          letter-spacing: .1em;
          text-transform: uppercase;
          color: var(--brand-deep);
          margin-bottom: 20px;
          text-align: center;
          position: relative;
        }
        .prof-section-title::after {
          content: '';
          display: block;
          width: 32px; height: 3px;
          background: linear-gradient(90deg, var(--brand-deep), var(--brand-light));
          border-radius: 3px;
          margin: 5px auto 0;
        }

        /* Fields */
        .prof-field { margin-bottom: 16px; }
        .prof-label {
          display: block;
          margin-bottom: 7px;
          font-size: .7rem;
          font-weight: 500;
          color: var(--brand-muted);
          text-transform: uppercase;
          letter-spacing: .09em;
        }

        /* Input overrides */
        .prof-input,
        .prof-input.form-control {
          background: #f7fbf9 !important;
          border: 1px solid var(--brand-border) !important;
          border-radius: 10px !important;
          color: var(--brand-deep) !important;
          font-family: var(--font-body) !important;
          font-size: 15px !important;
          padding: 11px 14px !important;
          width: 100% !important;
          outline: none !important;
          transition: border-color .2s, box-shadow .2s, background .2s;
          -webkit-appearance: none;
          caret-color: var(--brand-mid);
        }
        .prof-input::placeholder { color: var(--brand-muted) !important; opacity: .6; }
        .prof-input:focus,
        .prof-input.form-control:focus {
          border-color: var(--brand-mid) !important;
          box-shadow: 0 0 0 3px rgba(26,138,88,.14), 0 0 14px rgba(26,138,88,.08) !important;
          background: #fff !important;
        }
        .prof-input-disabled,
        .prof-input-disabled.form-control {
          color: var(--brand-muted) !important;
          cursor: not-allowed !important;
          border-color: rgba(200,223,212,.5) !important;
          background: #f0f4f2 !important;
        }

        /* Save button */
        .prof-save-btn {
          width: 100%;
          padding: 13px;
          border-radius: 12px;
          font-family: var(--font-display);
          font-weight: 700;
          font-size: 1rem;
          letter-spacing: .1em;
          text-transform: uppercase;
          background: linear-gradient(135deg, var(--brand-deep) 0%, var(--brand-mid) 100%);
          border: none;
          color: #fff;
          margin-top: 8px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          transition: transform .2s, box-shadow .2s, filter .2s;
          box-shadow: 0 4px 18px rgba(14,77,53,.28);
        }
        .prof-save-btn::before {
          content: '';
          position: absolute; inset: 0;
          background: linear-gradient(135deg, rgba(255,255,255,.14) 0%, transparent 60%);
          opacity: 0;
          transition: opacity .2s;
        }
        .prof-save-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 28px rgba(14,77,53,.38);
          filter: brightness(1.08);
        }
        .prof-save-btn:hover::before { opacity: 1; }
        .prof-save-btn:active { transform: scale(.98); }

        /* Validation */
        .invalid-feedback { font-size: 11px; color: #c0392b !important; }

        /* Footer label */
        .prof-footer-label {
          text-align: center;
          font-size: .68rem;
          letter-spacing: .08em;
          color: var(--brand-muted);
          text-transform: uppercase;
          padding: 4px 0 20px;
          opacity: .7;
        }

        /* ── MOBILE ── */
        @media (max-width: 576px) {
          .prof-input,
          .prof-input.form-control { font-size: 16px !important; }
          .prof-page { padding-top: 58px; }
        }

        * { box-sizing: border-box; }
      `}</style>
    </React.Fragment>
  )
}

UserProfile.propTypes = {
  editProfile: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any,
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, { editProfile, resetProfileFlag })(UserProfile)
)